export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00679.782bb8fc.png";